export interface Request {
  message: string;
  code: string;
}

export const createRequest = (
  message: string = "",
  code: string = ""
): Request => ({
  message: message,
  code: code,
});
